import { useState, useEffect } from "react";
import client from "../../../../../helpers/Client";
import urlToId from "../../../../../helpers/UrlToId";
import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton } from "@chakra-ui/react";
import Select from "react-select";

export default function AssignTicketModal({
  ticket,
  state,
  revalidator,
}) {
  const [resellers, setResellers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedResellerURL, setSelectedResellerURL] = useState(ticket?.assigned_to?.url || "");

  useEffect(() => {
    let url = "/resellers/";
    if (ticket?.customer?.city) {
      // Extract city ID from URL if it's a URL, otherwise use it directly
      const cityId = typeof ticket.customer.city === 'string' && ticket.customer.city.includes('/') 
        ? urlToId(ticket.customer.city) 
        : ticket.customer.city;
      url += `?cities=${cityId}`;
    }
    client.get(url).then((response) => {
      const formattedResellers = response.data.map(reseller => ({
        value: reseller.url,
        label: reseller.name
      }));
      setResellers(formattedResellers);
    });
  }, [ticket?.customer?.city]);

  const handleResetFilter = () => {
    setLoading(true);
    client
      .get("/resellers/")
      .then((response) => {
        const formattedResellers = response.data.map(reseller => ({
          value: reseller.url,
          label: reseller.name
        }));
        setResellers(formattedResellers);
        setLoading(false);
        setSelectedResellerURL("");
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    const ticketId = ticket?.id || ticket?.pk || urlToId(ticket?.url);
    if (!ticketId) {
      console.error('Ticket ID not found:', ticket);
      return;
    }
    
    client
      .post(`/tickets/${ticketId}/assign/`, {
        assigned_to: selectedResellerURL,
      })
      .then(() => {
        revalidator.revalidate();
        state.onClose();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const selectedOption = resellers.find(reseller => reseller.value === selectedResellerURL);

  return (
    <Modal isOpen={state.isOpen} onClose={state.onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Bayi Ata</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Select
            value={selectedOption}
            onChange={(option) => setSelectedResellerURL(option?.value || "")}
            options={resellers}
            placeholder="Bayi seçin veya arayın..."
            isClearable
            isSearchable
            noOptionsMessage={() => "Bayi bulunamadı"}
          />
          <Button
            isLoading={loading}
            variant="ghost"
            size="xs"
            onClick={handleResetFilter}
            mt={2}
          >
            Bayinizi bulamıyor musunuz?
          </Button>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={state.onClose}>
            Vazgeç
          </Button>
          <Button colorScheme="teal" onClick={handleSubmit}>
            Kaydet
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
